import React from "react";
import ICONS from "src/assets/icons";
import { Button } from "src/components/buttons";
import africa from "src/assets/images/africa.gif";
import TypeFormEmbed from "../typeforms";
import CustomModal from "src/components/modals";
import orange from "src/assets/images/orange.png";
import nvidia from "src/assets/images/nvidia.webp";
import forvismazars from "src/assets/images/forvismazars.png";
import myriad from "src/assets/images/myriad.png";
import cloudoor from "src/assets/images/whitecloudoor.png";

const GetStartedSection: React.FC = () => {
  const [isVisibleTypeForm, setIsVisibleTypeForm] = React.useState(false);

  return (
    <div className="flex flex-col md:flex-row w-full gap-8 text-white px-[3rem] noise-background-image mb-[4rem]">
      <div className="w-full md:w-[60%] mt-[5rem] mx-auto">
        <h1 className="text-[40px] sm:text-[50px] md:text-[63px] font-[400] leading-[1.1]">
          Souveraineté
          <i className="app-title-italic text-[#20E87F] font-[400] leading-[75.6px]">
            {" "}
            immédiate,{" "}
          </i>{" "}
          <br />
          Technologie de{" "}
          <i className="app-title-italic text-[#20E87F] font-[400] leading-[75.6px]">
            pointe
          </i>
        </h1>

        <h1 className="text-[#FFFFFF8C] text-[20px] mt-[2rem] font-[400] leading-[30px]">
          Cloud souverain, aussi moderne, performant et rentable que les grands
          clouds publics, <br />
          DOOR garantit une transformation immédiate tout en minimisant la
          résistance au changement.
        </h1>
        <Button
          className="mt-[2rem] flex xs:h-[40px] sm:h-[40px] md:h-[4px] lg:h-[45px] xl:h-[45px] xs:p-[8px] sm:p-[8px]  md:p-[15px] lg:p-[15px] xl:p-[15px] justify-center items-center gap-[8px] rounded-[12px] [background:var(--main-gradient,linear-gradient(90deg,#145BF0_0%,#1DC66D_100%))]"
          onClick={() => setIsVisibleTypeForm(true)}
        >
          REJOIGNEZ-NOUS <i className="bi bi-arrow-right"></i>
        </Button>
        <div className="flex flex-col md:flex-row w-full  mt-[4rem]  mb-[3rem] text-white ">
          <div className="w-full md:w-[50%]">
            <div className="flex items-center">
              {ICONS.Indicator()}
              <p className="ml-3 text-[32px]">28X</p>
            </div>
            <div className="text-[#FFFFFF8C] mt-[1rem]">
              <i className="text-sm">
                Avec Cloudoor, Sonatel délivre 28 fois plus rapide de nouvelles
                fonctionnalités.
              </i>
            </div>
          </div>
          <div className="w-full md:w-[50%] border-l-2 border-l-gray-500 pl-4">
            <div className="flex items-center">
              {ICONS.Graph()}
              <p className="ml-3 text-[32px]">410%</p>
            </div>
            <div className="text-[#FFFFFF8C] mt-[1rem]">
              <i className="text-sm">
                Réduit drastiquement de 410 % les interruptions de service.
              </i>{" "}
              <br />
            </div>
          </div>
        </div>
        <p className="font-bold leading-[1.2] text-center sm:text-left sm:ml-0 lg:ml-[12rem]">
          DES PARTENAIRES DE CONFIANCE:
        </p>
        <div className="flex items-center ml-[2rem] py-6">
          <div className="flex items-center justify-center bg-transparent rounded-full  px-6 py-3 gap-4 sm:gap-6 lg:justify-between">
            <img
              src={cloudoor}
              alt="Cloudoor"
              className="h-2 sm:h-8 md:h-[1.5rem] lg:h-12 xl:h-[2rem]"
            />
            <img
              src={orange}
              alt="Orange"
              className="h-6 sm:h-8 md:h-[2rem] lg:h-12 xl:h-[4rem]"
            />
            <img
              src={nvidia}
              alt="NVIDIA"
              className="h-6 sm:h-8 md:h-[2rem] lg:h-12 xl:h-[5rem] ml-[0.5rem]"
            />
            <img
              src={forvismazars}
              alt="Forvus Mazars"
              className="h-6 sm:h-8 md:h-[2rem] lg:h-12 xl:h-[5rem]"
            />
            <img
              src={myriad}
              alt="Myriad Connect"
              className="h-4 sm:h-8 md:h-[2rem] lg:h-12 xl:h-[2.5rem]"
            />
          </div>
        </div>
      </div>
      <div className="hidden md:block w-full md:w-[40%]">
        <div className="w-full h-auto max-w-[479px] max-h-[500px] flex items-center justify-center mt-[5rem]">
          <img src={africa} alt="phone" className="w-full h-auto" />
        </div>
      </div>

      {isVisibleTypeForm && (
        <CustomModal
          isOpen={isVisibleTypeForm}
          onClose={() => setIsVisibleTypeForm(false)}
          title=""
        >
          <TypeFormEmbed />
        </CustomModal>
      )}
    </div>
  );
};

export default GetStartedSection;
